module.exports = __webpack_public_path__ + "img/hotdocs.e4508ce8.jpg";